import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { FooterComponent } from  './shared/components/footer/footer.component'
import { AppRoutingModule } from './app-routing.module'
import { LayoutModule } from '@angular/cdk/layout'
import { SanitizeHtmlPipe } from './shared/components/article/SanitizeHtmlPipe'
import { LicensuresComponent } from './shared/components/licensures/licensures.component'
import { SafePipe } from './shared/pipes/safe.pipe'
import { RouterModule } from '@angular/router'
import { HeaderComponent } from './shared/components/header/header.component'
//import { DropDownListModule } from '@syncfusion/ej2-angular-dropdowns'
import { HeaderSearchComponent } from './shared/components/header-search/header-search.component'
import { ChatComponent } from './shared/components/chat/chat.component';
import { ModalOptionsComponent } from './shared/components/modal-options/modal-options.component';
import { SideButtonsComponent } from './shared/components/side-buttons/side-buttons.component';
import { ComponentControlsComponent } from './shared/components/component-controls/component-controls.component';
import { VideoPlayerComponent } from './shared/components/video-player/video-player.component';
import { TimePipePipe } from './shared/pipes/time-pipe.pipe';
import { ModalOptionsMainComponent } from './shared/components/modal-options/modal-options-main/modal-options-main.component';
import { ModalOptionsModule } from './shared/components/modal-options/modal-options.module';
import { LazyImgDirective } from './shared/pipes/lazy-img.directive';
import { ActivateModalComponent } from './shared/components/activate-modal/activate-modal.component'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { ClickOutsideDirective } from './shared/directives/click-outside.directive'
import { FormFieldComponent } from './shared/components/form-field/form-field.component'

import { NgSelectModule } from '@ng-select/ng-select';

import {TranslateHttpLoader} from '@ngx-translate/http-loader'
import { HttpClient } from '@angular/common/http';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core'
import { CustomHttpLoader } from './TranslateService'
import { RouteDataService } from './RouteDataService'
import { SharedDataService } from './core/services/shared-data.service'


/* export function HttpLoaderFactory(http:HttpClient){
  return new TranslateHttpLoader(http,  `https://assetsuat.icreditworks.com/public/webapp/assets/other/i18n/`, '.json');
}
  */


/*  export function MyCustomHttpLoaderFactory(myUserService: RouteDataService, httpClient: HttpClient) {
    return new MyCustomHttpLoader(myUserService, httpClient);
  }
  */
  export function CustomHttpLoaderFactory( httpClient: HttpClient) {
    return new CustomHttpLoader(httpClient);
  }
 
@NgModule({
    declarations: [
        FooterComponent,
        HeaderComponent,
        SanitizeHtmlPipe,
        LicensuresComponent,
        SafePipe,
        TimePipePipe,
        HeaderSearchComponent,
        LazyImgDirective,
        // General Compnents
        ChatComponent,
        // ModalOptionsComponent,
        SideButtonsComponent,
        ComponentControlsComponent,
        // ModalOptionsMainComponent,
        VideoPlayerComponent,
        ActivateModalComponent,
        ClickOutsideDirective,
        FormFieldComponent,
    ],
    imports: [
       NgSelectModule,
        CommonModule,
        RouterModule,
        LayoutModule,
        ModalOptionsModule,
       // DropDownListModule,
        FormsModule,
        ReactiveFormsModule,
      /*      TranslateModule.forRoot({
               loader: {
                   provide: TranslateLoader,
                   useFactory: HttpLoaderFactory,
                   deps: [ HttpClient],
               },
               defaultLanguage: 'en'
             }) ,
       */
         TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: CustomHttpLoaderFactory,
                deps: [ HttpClient],
            },
            //defaultLanguage: 'en',
            fallbackLang: 'en'
          }) , 
     ],
    exports: [
        ModalOptionsModule,
        FooterComponent,
        HeaderComponent,
        SanitizeHtmlPipe,
        LicensuresComponent,
        SafePipe,
        TimePipePipe,
        // General Compnents
        ChatComponent,
        SideButtonsComponent,
        ComponentControlsComponent,
        VideoPlayerComponent,
        LazyImgDirective,
        ClickOutsideDirective,
        ActivateModalComponent,
        FormFieldComponent,
    ], 
    providers: [RouteDataService, SharedDataService]
})
export class SharedModule {}
